import { lazy } from 'react'
import { registerEditor } from '../editor-registry.js'

const LazyDataGridViewer = lazy(() =>
  import('../../ui/DataGridViewer.js').then(m => ({ default: m.DataGridViewer }))
)

// Parquet: view-only (binary, no collaborative editing)
registerEditor({
  // (#823: no notifiesFileGone — parquet never joins a room, so the tab's host shows the "deleted" notice)
  family: 'datagrid',
  extensions: ['parquet'],
  name: 'Data Grid Viewer',
  component: LazyDataGridViewer,
  readOnly: true,
  binaryExtensions: ['parquet'],
})
